function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 8,
  fill: "#EEBC09"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.53 12.923a.197.197 0 01-.12-.039.185.185 0 01-.04-.116l-.172-5.613c0-.043.014-.078.04-.104a.167.167 0 01.12-.051h1.547c.044 0 .08.017.106.051.035.026.053.06.053.104l-.199 5.613a.158.158 0 01-.053.116.145.145 0 01-.105.039h-1.178zM12.044 16c-.3 0-.551-.094-.754-.283a1.006 1.006 0 01-.291-.734c0-.3.097-.545.291-.734.194-.189.445-.283.754-.283s.556.094.74.283a.979.979 0 01.292.734c0 .292-.097.536-.291.734a1.018 1.018 0 01-.74.283z",
  fill: "#000"
});

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgWarning;